export abstract class AppVersionService {
	public abstract config(): Promise<null>;
	public abstract get uiVersion();
	public abstract get serverVersion();
}
